import { actions, send } from 'xstate';
import { ActionTypes, CityActionTypes } from 'model/actions';
import { ResourceTypes } from 'model/party/resources/resources';
import Locations from 'model/locations';
import Calendar from 'model/calendar';
import Debug from 'debug';

/* eslint-disable-next-line no-unused-vars */
const debug = Debug('model.party.history.machine.handlers');

const { pure } = actions;

export const handleWalk = pure((_, event) => {
  if (event.result.success) {
    return send({
      type: 'ARRIVE',
      result: event.result,
      context: event.context
    });
  }
});

export const handleArrive = ({ party }, event) => {
  party.nextPhase();
  party.phases.disableAction(ActionTypes.Walk);
};

export const handleTakeBowl = ({ party }, event) => {
  party.phases.enableCityAction(CityActionTypes.Rest);
  party.phases.enableCityAction(CityActionTypes.Beg);
};

export const handleEnableHeal = ({ party }, event) => {
  party.phases.enableCityAction(CityActionTypes.BuyMedicine);
};

export const handleEnableRob = ({ party }, event) => {
  party.phases.enableCityAction(CityActionTypes.Rob);
  party.phases.enableResource(ResourceTypes.Ammo);
};

export const handleEnableWork = ({ party }, event) => {
  party.phases.enableCityAction(CityActionTypes.Work);
};

export const handleEnableGoal = ({ party }, event) => {
  party.phases.enableCalendar(Calendar.FULL);
};

export const handleEnableShop = ({ party }, event) => {
  party.phases.enableCityAction(CityActionTypes.TradePost);
};

export const handleGetHorse = ({ party }, event) => {
  party.phases.enableAction(ActionTypes.Depart);
};

export const handleDepart = (context, event) => {
  // Logic to handle the DEPART action
};

export const handleDie = (context, event) => {
  context.party.phases.disableAction(ActionTypes.Depart);
  context.party.phases.disableAction(ActionTypes.Forage);
  context.party.phases.disableAction(ActionTypes.Hunt);
  context.party.phases.disableAction(ActionTypes.Rest);
};

export const handleStartTraveling = (context, event) => {
  context.party.phases.enableAction(ActionTypes.Forage);
  context.party.phases.enableAction(ActionTypes.Hunt);
  context.party.phases.enableAction(ActionTypes.Rest);
  context.party.phases.enableAction(ActionTypes.Depart);
  context.party.phases.enableLocation(Locations.Road.index);
  context.party.phases.enableLocation(Locations.City.index);
};
